import React, { useContext } from 'react'
import GreyBoxForReports from './GreyBoxForReports'
import { ApiGetCall } from '../../JS/Connector';
import { formatDateToMMDDYYYY, formatDateToUsaMMDDYYYY } from '../../JS/Common';
import AlertsComp from '../../Components/AlertsComp';
import { log } from '../../JS/Logger';
import useConfig from '../../Hooks/useConfig';

export default function SchoolPurchases({ setLoading, FilterData, setalerts, downloadAllChecked }) {
    const {organization, student_number} = useConfig();
    async function GetAllSchoolPurchaseData() {
        var downloadall = 0;
        if (downloadAllChecked) {
            downloadall = 1;
        }
        setLoading(true);
        await ApiGetCall(`/reports/individual-purchases?startDate=${formatDateToMMDDYYYY(FilterData.StartDate)}&endDate=${formatDateToMMDDYYYY(FilterData.EndDate)}&locationId=${FilterData.Location}&schoolId=${FilterData.School}&flag=${downloadall}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs?.data?.length > 0) {
                    DownloadCsv(responseRs.data);
                } else {
                    DownloadCsv([]);
                    setalerts(<AlertsComp show={true} variant="danger" msg={"No Data Found"} />);
                    setTimeout(() => {
                        setalerts(<AlertsComp show={false} />);
                    }, 2000);
                }
                setLoading(false);
            }
        });
    }
    const DownloadCsv = (CsvData) => {
        const csvContent = [];
        const PurchaseMap = [];
        CsvData?.forEach((item) => {
            const rowData = {
                [`${organization} Name`]: item.school || '-',
                'Club Name': item.plan_name || '-',
                [student_number]: item.student_num || '-',
                'Paid Amount': item.paid_amount ? `$${item.paid_amount}` : '-',
                'Purchased At': item.created_at ? formatDateToUsaMMDDYYYY(item.created_at) : '-',
                'Stripe Payment ID': item.stripe_paymnet_id ? item.stripe_paymnet_id : "-",
            };
            PurchaseMap.push(rowData);
        });
        if (PurchaseMap.length > 0) {
            const headers = [`${organization} Name`, 'Club Name', student_number, 'Paid Amount', 'Purchased At', 'Stripe Payment ID'];
            csvContent.push(headers);
            PurchaseMap.forEach((rowData) => {
                const values = Object.values(rowData).map(value => {
                    if (typeof value == 'string' && value.includes(',')) {
                        return `"${value}"`;
                    }
                    return value;
                });
                csvContent.push(values);
            });
            csvContent.push([]);
            const csvString = csvContent.map((row) => row.join(',')).join('\n');
            const blob = new Blob([csvString], { type: 'text/csv' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `PurchasesBy${organization}.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            log.error('No data available for download.');
        }
    };
    return (
        <GreyBoxForReports icon="faTags" name={`Detailed Device Club Purchase Transactions by ${organization} Download`} onclickfunc={GetAllSchoolPurchaseData} />

    )
}
